import React from 'react'
import { useOnScreen } from '../utility/util';

export default function InfiniteLoading({ identifier, setPage : onChangePage, items = [], render }){
    const [page, setPage] = React.useState(0);
    const [ignoreInitial, setIgnoreInitial] = React.useState(true);
    const endingRef = React.useRef();
    const isVisible = useOnScreen(endingRef);
    
    React.useEffect(() => {
        if (isVisible && document.documentElement.scrollTop > 500) { setPage(p => p+1); }
    }, [isVisible, ignoreInitial])
    
    React.useEffect(() => { console.log(page); onChangePage(page); }, [page]);
    React.useEffect(() => { setPage(0); }, [identifier]);

    return <div>
        {items.slice(0, items.length - 1).map(render)}
        <div ref={endingRef}></div>
        {items.slice(items.length - 1).map(render)}
    </div>
}